// this constant is different from what we havee in 'app_constants', as we need 0 to be Monday
export const DAYS_ALLOWED_TO_WORK = [
  { value: 0, text: 'mon' },
  { value: 1, text: 'tue' },
  { value: 2, text: 'wed' },
  { value: 3, text: 'thu' },
  { value: 4, text: 'fri' },
  { value: 5, text: 'sat' },
  { value: 6, text: 'sun' },
];

// the pluralWord is optional
// e.g: pluralize(2, 'filter') => 'filters'
//      pluralize(1, 'filter') => 'filter'
//      pluralize(2, 'index', 'indexes') => 'indexes'
//      pluralize(1, 'index', 'indexes') => 'index'
export function pluralize(count, singularWord, pluralWord) {
  if (!singularWord) {
    return '';
  }

  if (typeof pluralWord === 'undefined') {
    pluralWord = singularWord + 's';
  }

  if (Math.round(count) !== 1) {
    return pluralWord;
  }

  return singularWord;
}

/**
 * Takes a string and turns all characters into lowercase
 * @param {string} value - 'ExaMpLE oF StRIng'
 * @returns {string} - 'example of string'
 */

export function lowercase(value) {
  if (!value) {
    return '';
  }

  return value.toLowerCase();
}

/**
 * Takes an array of days and returns a string of working days.
 *
 * @param {array} days - ['mon', 'wed', 'thu', 'fri', 'sun']
 * @returns {string} - 'Mon, Wed - Fri, Sun'
 */

export function daysOfWork(days) {
  // Sort days so it starts from Monday
  const _days = [...days].sort(
    (a, b) =>
      DAYS_ALLOWED_TO_WORK.find((day) => day.text === a).value -
      DAYS_ALLOWED_TO_WORK.find((day) => day.text === b).value,
  );
  const allDays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  const result = [];
  let startRange = _days[0];

  for (let i = 1; i < _days.length; i++) {
    // if days are not in a row
    if (allDays.indexOf(_days[i]) - allDays.indexOf(_days[i - 1]) !== 1) {
      if (startRange !== _days[i - 1]) {
        result.push(startRange + ' - ' + _days[i - 1]);
      } else {
        result.push(startRange);
      }
      startRange = _days[i];
    }
  }

  // For the last day/range
  if (startRange !== _days[days.length - 1]) {
    result.push(startRange + ' - ' + _days[_days.length - 1]);
  } else {
    result.push(startRange);
  }

  return result.join(', ');
}
